import { View } from 'backbone.marionette';
import Backbone from 'backbone';

import StringCell from '@/backgrid/StringCell';

import OrderSummaryGridView from '../../../views/OrderSummaryGridView/OrderSummaryGridView';

import tmplMaintenanceSummaryView from './MaintenanceSummaryView.hbs';
import './MaintenanceSummaryView.css';

const MaintenanceSummaryView = View.extend({
  template: tmplMaintenanceSummaryView,

  className: 'maintenance-summary-view',

  ui: {
    summaryTable: '.summary-table'
  },

  regions: {
    summaryTable: '@ui.summaryTable'
  },

  onRender() {
    this.columns = [
      {
        name: 'item',
        label: 'Item',
        cell: StringCell,
        headerCell: 'custom',
        width: 75,
        editable: false
      },
      {
        name: 'quantity',
        label: 'Quantity',
        cell: StringCell,
        headerCell: 'custom',
        width: 25,
        editable: false
      }
    ];

    this.collection = new Backbone.Collection([
      {
        item: 'Devices for Maintenance',
        quantity: this.model.get('order').numDevicesForMaintenance
      },
      {
        item: 'Firmware/Software Updates',
        quantity: this.model.get('order').numFirmwareSoftwareUpdates
      },
      {
        item: 'Onsite Technicians',
        quantity: this.model.get('order').numOnsiteTechnicians
      },
      {
        item: 'Order Total',
        quantity: this.model.get('order').totalOrderQuantity
      }
    ]);

    this.orderSummaryGridView = new OrderSummaryGridView({
      model: this.model,
      collection: this.collection,
      columns: this.columns
    });
    this.showChildView('summaryTable', this.orderSummaryGridView);
  }
});

export default MaintenanceSummaryView;
